import PseudoLink from './PseudoLink'

export default PseudoLink
